import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import InnereRuheFinden from "./sections/InnereRuheFinden";
import ThePathToYourself from "./sections/ThePathToYourself";
import HealingMethods from "./sections/HealingMethods";
import SwissRetreatExperiences from "./sections/SwissRetreatExperiences";
import PatientVoices from "./sections/PatientVoices";
import SichtbarkeitPlanen from "./sections/SichtbarkeitPlanen";
import Abschluss from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <InnereRuheFinden />
      <ThePathToYourself />
      <HealingMethods />
      <SwissRetreatExperiences />
      <PatientVoices />
      <SichtbarkeitPlanen />
      <Abschluss />
    </div>;
}